import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTheme, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  newsText: {
    '& a': {
      color: theme.customColors.active,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
}));

const NewsItem = ({ size, date, text, compact }) => {
  const classes = useStyles();
  const isSmall = size === 'small';
  const fontSize = compact ? '0.75rem' : isSmall ? '0.875rem' : '1rem';
  const dateWidth = compact ? 70 : isSmall ? 80 : 120;

  return (
    <Box display="flex" flexDirection="row" mb={compact ? 1 : 2}>
      <Box minWidth={dateWidth} mr={compact ? 1 : 2}>
        <Typography
          style={{ fontSize, fontWeight: 600 }}
          component="div"
        >
          {date}
        </Typography>
      </Box>
      <Box flexGrow={1}>
        <Typography
          style={{ fontSize }}
          component="div"
          className={classes.newsText}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </Box>
    </Box>
  );
};

export { NewsItem };
